<template>
  <v-dialog
    v-model="isOpen"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :width="$vuetify.breakpoint.smAndDown ? '' : 500 "
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>

     <v-card>
      <v-card-title>
        {{ $t('請將 QRCODE 對準掃瞄框') }}
        <v-spacer></v-spacer>
        <v-btn icon large @click="isOpen = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="scanner my-3" style="height: 30vh;">
          <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
            <div class="scan-area">
              <div class="top"></div>
              <div class="bottom"></div>
            </div>
          </qrcode-stream>
        </div>

        <v-alert
          v-if="error"
          type="error"
          icon="mdi-alert"
          class="mt-2"
          outlined
        >
          {{ error }}
        </v-alert>

        <v-btn
          color="primary"
          depressed
          large
          block
          :loading="isLoading"
          @click="rescan"
          class="mt-4"
          :disabled="!hasScanned"
        >
          {{ $t('重新掃描') }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader';
import { mapGetters } from 'vuex';

export default {
  components: {
    QrcodeStream
  },

  data() {
    return {
      isLoading: false,
      isOpen: false,
      phoneNo: "",
      cardNo: "",
      puk: "",
      camera: 'auto',
      error: "",
      hasScanned: false,
      error: null,
      audio: new Audio('/audio/scan.mp3'),
    }
  },

  computed: {
    sim() {
      return this.simByCardNo(this.cardNo);
    },

    ...mapGetters('sims', {
      simByCardNo: 'byCardNo',
    }),
  },

  methods: {
    async onDecode (decodedResult) {
      this.audio.play();
      this.camera = 'off';
      this.hasScanned = true;
      try {
        this.phoneNo = decodedResult.split(",")[0];
        this.cardNo = decodedResult.split(",")[1];
        this.puk = decodedResult.split(",")[2];

        this.$nextTick(() => {
          if (!this.sim) {
            this.error = this.$t('此卡不在庫存內，請聯絡相關人員。');
          } else {
            this.submit();
          }
        });
      } catch (error) {
        this.error = this.$t('掃描錯誤，內容如下:') + decodedResult;
      }
    },

    async onInit (promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$t('您必須打開鏡頭權限');
        } else if (error.name === 'NotFoundError') {
          this.error = this.$t('找不到相機');
        } else if (error.name === 'NotSupportedError') {
          this.error = this.$t('ERROR: secure context required (HTTPS, localhost)');
        } else if (error.name === 'NotReadableError') {
          this.error = this.$t('相機已經被其他程式佔用');
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$t('ERROR: installed cameras are not suitable');
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$t('系統無法支援此瀏覽器');
        }
      }
    },

    submit() {
      this.$emit('decode', {
        phone: this.phoneNo,
        card: this.cardNo,
      });
      this.isOpen = false;
      this.resetData();
      this.rescan();
    },

    resetData() {
      this.error = null;
      this.hasScanned = false;
      this.phoneNo = null;
      this.cardNo = null;
    },

    rescan() {
      this.resetData();
      this.camera = 'auto';
    }
  }
}
</script>

<style lang="scss" scoped>
.scan-area {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40%;
  padding-bottom: 40%;
  z-index: 999;
  transform: translate(-50%, -50%);
  opacity: 0.8;

  .top {
    &:before,
    &:after {
      content: "";
      display: block;
      width: 30px;
      height: 30px;
      border: 5px solid #fff;
      border-right: 0;
      border-bottom: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 999;
    }

    &:after {
      right: 0;
      left: initial;
      transform: scaleX(-1);
    }
  }

  .bottom {
    &:before,
    &:after {
      content: "";
      display: block;
      width: 30px;
      height: 30px;
      border: 5px solid #fff;
      border-right: 0;
      border-top: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 999;
    }

    &:after {
      right: 0;
      left: initial;
      transform: scaleX(-1);
    }
  }
}
</style>
